import { Stack, useFocusEffect, useRouter } from "expo-router";
import { View } from "react-native";
import PageTemplate from "../../components/common/page-template";
import { useCallback } from "react";
import { Banknote } from "lucide-react-native";
import { useSettingsData } from "../../contexts/SettingsDataContext";
import { useStripeClientSecret } from "../../contexts/StripeClientSecretContext";
import LoadingView from "../../components/common/loading-view";
import { useActiveAgent } from "../../contexts/ActiveAgentContext";
import EarningsTabs from "../../components/feature/earnings/earnings-tabs";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { isPickupPaymentsEnabled } from "../../utils/setting-helpers";

const EarningsLayout = () => {
  const router = useRouter();

  useFocusEffect(
    useCallback(() => {
      // hide crisp chatbox on earnings page
      document.body.setAttribute("data-page", "earnings");
      return async () => {
        document.body.removeAttribute("data-page");
      };
    }, [])
  );

  const { agentsLoading } = useActiveAgent();
  const { settings, isLoading, stripeAccountStatus } = useSettingsData();
  const { clientSecret } = useStripeClientSecret();
  const { isPaymentsFeatureEnabled } = useFeatureFlags();
  const isPaymentsEnabled = isPickupPaymentsEnabled(settings?.orderingConfig);

  useFocusEffect(
    useCallback(() => {
      // Check if payments feature is available for this user
      if (!isPaymentsFeatureEnabled()) {
        router.replace("/");
        return;
      }

      if (isLoading || agentsLoading) {
        return;
      }
      if (stripeAccountStatus === "READY" && clientSecret) {
        if (isPaymentsEnabled) {
          router.replace("/earnings/payouts");
        } else {
          router.replace("/earnings/account");
        }
      } else {
        router.replace("/earnings/setup");
      }
    }, [
      isPaymentsEnabled,
      stripeAccountStatus,
      isLoading,
      agentsLoading,
      clientSecret,
      router,
    ])
  );

  if (isLoading || agentsLoading) {
    return (
      <PageTemplate
        title="Earnings"
        headerIcon={Banknote}
        className="bg-[#f2f2f2]"
      >
        <LoadingView />
      </PageTemplate>
    );
  }

  return (
    <PageTemplate title="Earnings" headerIcon={Banknote}>
      <View className="flex-1">
        {stripeAccountStatus === "READY" && clientSecret && <EarningsTabs />}
        <View className="flex-1">
          <Stack
            screenOptions={{
              headerShown: false,
              contentStyle: {
                // backgroundColor: "#ecfdf5",
              },
            }}
          />
        </View>
      </View>
    </PageTemplate>
  );
};

export default EarningsLayout;
